<template>
  <el-drawer :before-close="handleClose" :visible.sync="show" size="420px" :title="role + '详细信息'">
    <div v-loading="loading" style="padding: 20px">
      <el-descriptions :title="role + '信息'" :column="1">
        <el-descriptions-item label="名称">{{ info.userName }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ info.phoneNumber }}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{ info.idNumber }}</el-descriptions-item>
        <el-descriptions-item v-if="info.userRole === 2" label="地区"></el-descriptions-item>
        <el-descriptions-item v-if="info.userRole === 2" labelStyle="display:none">
          <div style="margin-left: 20px;" v-for="(e, index) in regions" :key="index">{{ e }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="注册时间">{{ info.createTime }}</el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag size="small" v-if="info.enableState === 0" disable-transitions type="danger">未审核</el-tag>
          <el-tag size="small" v-else-if="info.enableState === 1" disable-transitions type="success">已审核</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="角色">
          <el-tag type="info" size="mini" v-if="info.userRole === 0">医生</el-tag>
          <el-tag type="primary" size="mini" v-if="info.userRole === 1">管理员</el-tag>
          <el-tag type="success" size="mini" v-if="info.userRole === 2">专家</el-tag>
        </el-descriptions-item>
        <el-descriptions-item v-if="info.userRole === 1" label="病历权限">
          <el-tag type="primary" size="mini" v-if="info.medicalRole === 0">可编辑</el-tag>
          <el-tag type="info" size="mini" v-if="info.medicalRole === 1">仅查看</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="微信绑定">
          <el-tag v-if="info.openId" type="success" size="mini">已绑定</el-tag>
          <el-tag v-else type="danger" size="mini">未绑定</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="职业能力">{{ info.professionalAbility }}</el-descriptions-item>
        <el-descriptions-item label="资质证书" />
        <el-descriptions-item label="" labelStyle="display:none">
          <div class="box">
            <div v-for="certification in info.certifications" :key="certification.uuid" class="box-item">
              <el-image :preview-src-list="[formatOssUrl(certification.url)]"
                :src="formatOssUrl(certification.url + process)" fit="cover" lazy style="width: 120px;height: 120px" />
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="上次登录 IP">{{ info.lastLoginIp }}</el-descriptions-item>
        <el-descriptions-item label="上次登录时间">{{ info.lastLoginTime }}</el-descriptions-item>
        <el-descriptions-item label="更新人">{{ info.updateUserName }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ info.updateTime }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>

<script>
import { getFullDoctorInfo } from '@/api/business/tenantUser/doctor'

export default {
  name: 'ShowDoctorInfo',
  data() {
    return {
      loading: false,
      role: '',
      regions: [],
      process: '?x-oss-process=image/resize,m_mfit,h_120,w_120',
      show: false,
      info: {
        userCode: '',
        userName: '',
        loginName: '',
        phoneNumber: '',
        idNumber: '',
        createTime: '',
        enableState: -1,
        professionalAbility: '',
        certifications: [],
        lastLoginIp: '',
        lastLoginTime: '',
        updateUserCode: '',
        updateUserName: '',
        updateTime: '',
        userRole: ''
      }
    }
  },
  methods: {
    open(userCode) {
      this.loading = true
      this.info.userCode = userCode
      getFullDoctorInfo(userCode).then(({ data }) => {
        this.loading = false
        if (data && data.code === 0) {
          this.info = data.data
          if (this.info.userRole === 2) {
            this.role = '专家'
          } else {
            this.role = '医生'
          }
          if (this.info.regionStr) {
            this.regions = this.info.regionStr.split(',')
          }
        }
      })
      this.show = true
    },
    handleClose(done) {
      this.info = {
        userCode: '',
        userName: '',
        loginName: '',
        phoneNumber: '',
        idNumber: '',
        createTime: '',
        enableState: -1,
        professionalAbility: '',
        certifications: [],
        lastLoginIp: '',
        lastLoginTime: '',
        updateUserCode: '',
        updateUserName: '',
        updateTime: '',
        userRole: ''
      }
      this.role = ''
      done()
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  display: -webkit-flex;
  /* Safari */
  display: flex;
  flex-wrap: wrap;

  .box-item {
    padding: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/showDoctorInfo/index.vue